import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components/macro";
import { Frame } from "@bitesite/react-figstrap";
import { Text } from "../../odc-ui";

import GiftBblFaceAndNeckTreatmentImage from "../../../assets/images/gifts/gift-bbl-face-and-neck-treatment.png";
import GiftBblFaceTreatmentImage from "../../../assets/images/gifts/gift-bbl-face-treatment.png";
import GiftBotox10Image from "../../../assets/images/gifts/gift-botox-10.png";
import GiftHaloFaceTreatmentImage from "../../../assets/images/gifts/gift-halo-face-treatment.png";
import GiftPicoRejuvenationTreatmentImage from "../../../assets/images/gifts/gift-pico-rejuvenation-treatment.png";
import GiftSyringeOfFillerImage from "../../../assets/images/gifts/gift-syringe-of-filler.png";
import GiftThermageTreatmentImage from "../../../assets/images/gifts/gift-thermage-treatment.png";
import GiftVivierImage from "../../../assets/images/gifts/gift-vivier.png";

const GiftPreviewImage = styled.img`
  height: 200px;
  width: 200px;
`;

const GiftPreview = ({ initialBalance }) => {
  const giftMap = {
    1000: GiftVivierImage,
    2000: GiftBotox10Image,
    3000: GiftBblFaceTreatmentImage,
    4000: GiftBblFaceAndNeckTreatmentImage,
    5000: GiftSyringeOfFillerImage,
    6000: GiftPicoRejuvenationTreatmentImage,
    8000: GiftHaloFaceTreatmentImage,
    10000: GiftThermageTreatmentImage,
  };

  if (giftMap[initialBalance]) {
    return (
      <Frame vertical alignItems="center" justifyContent="center">
        <Text>My Free Gift:</Text>
        <GiftPreviewImage src={giftMap[initialBalance]} />
      </Frame>
    );
  }

  return null;
};

GiftPreview.propTypes = {
  initialBalance: PropTypes.number,
};

export default GiftPreview;
